"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSimulator = void 0;

var _react = require("react");

var _services = require("../services");

var _contexts = require("../contexts");

var _utils = require("../utils");

const useSimulator = () => {
  const {
    interestRateType,
    open,
    openSimulator,
    closeSimulator,
    intendedCredit,
    setIntendedCredit,
    productType,
    setProductType,
    overrideRedirectToAuto,
    overrideRedirectToHome
  } = (0, _react.useContext)(_contexts.SimulatorContext);
  const isSimulationByProduct = (0, _react.useMemo)(() => (0, _utils.isProductType)(productType) && (0, _utils.isValidIntendedCredit)(intendedCredit, productType), [productType, intendedCredit]);

  const handleOpen = (initialValue, product) => {
    setIntendedCredit(initialValue != null ? initialValue : 0);
    setProductType(product != null ? product : '');
    openSimulator();
  };

  const handleClose = () => {
    (0, _services.dispatchCloseEvent)();
    closeSimulator();
  };

  return {
    interestRateType,
    openSimulator: handleOpen,
    closeSimulator: handleClose,
    open,
    setIntendedCredit,
    intendedCredit,
    productType,
    isSimulationByProduct,
    overrideRedirectToAuto,
    overrideRedirectToHome
  };
};

exports.useSimulator = useSimulator;